import MainTopBar from '@/components/common/bar/MainTopBar'
import { FileText } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import ReportListItem from '@/components/report/ReportListItem'
import { useGetMyReports } from '@/hooks/queries/report'
import PullToRefresh from '@/components/common/refresh/PullToRefresh'
import IncompleteReportListItem from '@/components/report/IncompleteReportListItem'
import { useScrollToTop } from '@/hooks/useScrollToTop'

export default function ReportPage() {
  useScrollToTop()

  const navigate = useNavigate()

  const { data: myReports } = useGetMyReports()

  const handleReportClick = (reportId: string) => {
    navigate(`/report/${reportId}`)
  }

  return (
    <>
      <MainTopBar
        leftSide={
          <div className='flex items-center'>
            <h1 className='text-header-title font-semibold text-text-header'>상담 리포트</h1>
          </div>
        }
      />
      <PullToRefresh
        onRefresh={() => {
          window.location.reload()
        }}
      >
        <div className='min-h-screen'>
          {/* 메인 콘텐츠 */}
          <div className='px-3 pb-32 pt-3'>
            {myReports?.reports && myReports.reports.length > 0 ? (
              <div className=' overflow-hidden'>
                <div className=''>
                  <div className='space-y-3'>
                    {myReports?.reports?.map(report => {
                      return report.is_complete ? (
                        <ReportListItem
                          key={`complete-report_${report.conversation_report_id}`}
                          id={report.conversation_report_id.toString()}
                          isNew={!report.is_read}
                          session={report.order}
                          date={report.report_date}
                          title={report.step_name}
                          subtitle={report.step_description}
                          handleReportClick={handleReportClick}
                        />
                      ) : (
                        <IncompleteReportListItem
                          key={`incomplete-report_${report.conversation_report_id}`}
                          order={report.order}
                        />
                      )
                    })}
                  </div>
                </div>
              </div>
            ) : (
              /* 빈 상태 메시지 */
              <div className='bg-white rounded-2xl shadow-lg overflow-hidden'>
                <div className='p-8 text-center'>
                  <div className='w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4'>
                    <FileText className='w-8 h-8 text-amber-600' />
                  </div>
                  <h3 className='text-lg font-bold text-gray-700 mb-2'>아직 리포트가 없어요</h3>
                  <p className='text-sm text-gray-500 leading-relaxed mb-4'>
                    상담을 진행하시면
                    <br />
                    리포트가 자동으로 생성됩니다
                  </p>
                  <button
                    onClick={() => navigate('/chat')}
                    className='bg-gradient-to-r from-amber-400 to-amber-600 text-white font-medium px-6 py-3 rounded-2xl text-sm hover:from-amber-500 hover:to-amber-700 transition-colors shadow-sm'
                  >
                    상담 시작하기
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </PullToRefresh>
    </>
  )
}
